import React from "react";
import { Input, Row, Col, Space, Select, Switch } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { EXPLORE_MODES } from "./constants";
import { DATA } from "../../myanfinviz";
import { RecordDetails } from "./commonUI/RecordDetails";
import { RecordDetailsList } from "./commonUI/RecordDetailsList";
import { SelectData } from "./commonUI/SelectData";
import * as _ from "lodash";
const FIELD = "Company Name In Myanmar";
const keyedData = _.keyBy(DATA, FIELD);

export default class Compare extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      firstPaneRecord: DATA[0],
      secondPaneRecord: DATA[1],
      listMode: true,
    };
  }

  onChangeFirstPane = (val) => {
    console.log("onChangeFirstPane", val);
    this.setState({ firstPaneRecord: keyedData[val] });
  };
  onChangeSecondPane = (val) => {
    console.log("onChangeFirstPane", val);
    this.setState({ secondPaneRecord: keyedData[val] });
  };
  
  onSwitchChange = (val) => {
    this.setState({
      listMode: val
    })
  }

  render = () => {
    const { listMode, firstPaneRecord, secondPaneRecord } = this.state;
    return (
      <div>
        <h3>{EXPLORE_MODES.COMPARE.label}</h3>
        <p>List Mode <Switch defaultChecked={listMode} onChange={this.onSwitchChange} /> </p>
        <Row>
          <Col className="compare-pane pr-2" span={12}>
            <SelectData
              defaultValue={DATA[0][FIELD]}
              onChange={this.onChangeFirstPane}
              className="mb-2"
            />
            <div className="details">
              {listMode ? <RecordDetailsList record={firstPaneRecord}/> : <RecordDetails record={firstPaneRecord} />}
            </div>
          </Col>
          <Col className="compare-pane pl-2" span={12}>
            <SelectData
              defaultValue={DATA[1][FIELD]}
              onChange={this.onChangeSecondPane}
              className="mb-2"
            />
            <div className="details">
              {listMode ? <RecordDetailsList record={secondPaneRecord}/> : <RecordDetails record={secondPaneRecord} />}
            </div>
          </Col>
        </Row>
      </div>
    );
  };
}
